import $ from 'jquery';
import detectMobile from '../libs/detect-mobile';


export default () => {
    //refresh page on browser resize
    if (detectMobile()) {
        window.addEventListener("orientationchange", function () {
            //$('body').removeClass('loaded');
            setTimeout(function () {
                //location.reload();
            }, 1000);
        });
    } else {
        window.addEventListener("resize", function () {
            //$('body').removeClass('loaded');
            setTimeout(function () {
                //location.reload();
            }, 1000);
        });
    }
};




// WEBPACK FOOTER //
// ./scripts/libs/page-refresh.js